import React from 'react';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class PackagedSubDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getPackagedSubData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      power_required,
      description,
      image,
    } = this.props.packagedSub;

    const { t, ref, disabled, fieldErrors, packagedSub, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="air-conditioning-package-sub-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder="Name"
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-package-sub-power-required"
          field="power_required"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-package-sub-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

PackagedSubDetail.defaultProps = {
  packagedSub: {},
};

export default translate('translations', { withRef: true })(PackagedSubDetail);



// WEBPACK FOOTER //
// ./src/components/ac_packaged_unit/PackagedSubDetail.js